import { stockbitIcon } from 'assets/base64icon';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import Image from 'global/Image';
import { PageWrapper } from './styled';

function NotFound() {
  return (
    <PageWrapper data-cy="global-not-found">
      <Image src={stockbitIcon} alt="Stockbit" />
      <Flex direction="column" width="calc(100% - 250px)">
        <Text as="h1" weight="700" color={color.nightRider} size="64px">
          Oops.
        </Text>
        <Text color={color.nightRider} size="16px">
          This page does not exist. So you got lost. It&quot;s ok. You should
          probably be safer to return to home.
        </Text>
        <Link href="/stream">
          <a>
            <Button>Back To Home</Button>
          </a>
        </Link>
      </Flex>
    </PageWrapper>
  );
}

export default NotFound;
